export const DELAY = {
	IMMEDIATE: 'Immediate',
	MINS_5: '5 min',
	MINS_10: '10 minutes',
	MINS_30: '30 minutes',
	HOUR_1: '1 hour',
};

export const DELAY_OPTIONS: Array<any> = [
	{
		label: DELAY.IMMEDIATE,
		value: 0,
	},
	{
		label: DELAY.MINS_5,
		value: 5,
	},
	{
		label: DELAY.MINS_10,
		value: 10,
	},
	{
		label: DELAY.MINS_30,
		value: 30,
	},
	{
		label: DELAY.HOUR_1,
		value: 60,
	},
];

export const DELAY_CONTACT_LABELS = {
	'0': 'Immediately',
	'5': '5 mins later',
	'10': '10 minutes later',
	'30': '30 minutes later',
	'60': '1 hour later',
};
